import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HammerModule } from '@angular/platform-browser';

import { ImageDialogComponent } from './image-dialog.component';
import { FcpIconModule } from 'fc-ui-components';
import { ModalModule } from 'app/shared/components/modal/modal.module';

@NgModule({
    imports: [CommonModule, ModalModule, HammerModule, FcpIconModule],
    declarations: [ImageDialogComponent],
    exports: [ImageDialogComponent]
})
export class ImageDialogModule {}
